import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { PrivateAxios } from '../../request/axios';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { validatePassword } from '../GlobalFunction';

const ChangePassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const { token } = location.state;

    const handlePasswordChange = (event) => {
        const inputPassword = event.target.value;
        setNewPassword(inputPassword);
        // Valider le mot de passe
        if (validatePassword(inputPassword, setErrorMessage)) {
            setErrorMessage('');
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Vérifiez si les mots de passe correspondent
        if (newPassword !== confirmPassword) {
            toast.error("Les mots de passe ne correspondent pas.");
            return;
        }

        // Valider le mot de passe avant de soumettre
        if (errorMessage || !validatePassword(newPassword, setErrorMessage)) {
            toast.error("Veuillez corriger les erreurs dans le formulaire.");
            return;
        }

        setIsLoading(true);
        try {
            const payload = { password: newPassword };
            await PrivateAxios.put('/user', payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                timeout: 0
            });
            toast.success('Mot de passe changé avec succès');
            localStorage.setItem('assistance-axa-token', token);
            navigate('/');
        } catch (error) {
            const message = error.response?.data?.message || error.message;
            Swal.fire('Erreur', `Erreur lors du changement de mot de passe : ${message}`, 'error');
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = async () => {
        try {
            await PrivateAxios.get('/logout');
        } finally {
            localStorage.removeItem('assistance-axa-token');
            navigate('/login');
        }
    };

    return (
        <div className="flex items-center justify-center h-screen bg-gray-100">
            <div className="relative w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
                {/* Logo */}
                <div className="flex justify-center mb-8">
                    <img className="w-32" src="/img/axa_logo_solid_rgb.png" alt="AXA Logo" />
                </div>

                {/* Titre */}
                <h1 className="mb-6 text-2xl font-bold text-center text-gray-800">Changer votre mot de passe</h1>

                {/* Formulaire de changement de mot de passe */}
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="newPassword" className="block mb-2 text-lg font-medium text-gray-700">
                            Nouveau mot de passe
                        </label>
                        <input
                            type="password"
                            id="newPassword"
                            value={newPassword}
                            onChange={handlePasswordChange}
                            className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 ${
                                errorMessage ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'
                            }`}
                            required
                            autoComplete="off"
                        />
                        {errorMessage && <p className="mt-2 text-sm text-red-500">{errorMessage}</p>}
                    </div>
                    <div>
                        <label htmlFor="confirmPassword" className="block mb-2 text-lg font-medium text-gray-700">
                            Confirmer le mot de passe
                        </label>
                        <input
                            type="password"
                            id="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                            autoComplete="off"
                        />
                    </div>

                    {/* Boutons */}
                    <div className="flex mt-6 space-x-4">
                        <button
                            type="submit"
                            className={`w-full py-3 rounded-md text-white font-semibold ${
                                isLoading || errorMessage
                                    ? 'bg-gray-500 cursor-not-allowed'
                                    : 'bg-axa-blue-400 hover:bg-blue-700'
                            }`}
                            disabled={isLoading || !!errorMessage}
                        >
                            {isLoading ? 'Chargement...' : 'Changer'}
                        </button>
                        <button
                            type="button"
                            onClick={handleCancel}
                            className={`w-full py-3 ${
                                isLoading ? 'bg-gray-500' : 'bg-danger-red hover:bg-red-600'
                            } text-white rounded-md font-semibold`}
                            disabled={isLoading}
                        >
                            Annuler
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePassword;
